import { useEffect } from 'react';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

export const logGAEvent = (
  eventName: string,
  eventParams?: Record<string, unknown>
) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
    console.log('GA Event logged:', eventName, eventParams);
  } else {
    console.warn('gtag not initialized:', eventName, eventParams);
  }
};

export default function GoogleAnalytics() {
  useEffect(() => {
    if (!GA_TRACKING_ID) {
      console.warn('Google Analytics Tracking ID is missing.');
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) {
      window.dataLayer.push(args);
    }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', GA_TRACKING_ID);
    console.log('GA Tracking ID:', GA_TRACKING_ID);
  }, []);

  return null;
}
